import React, { Component } from 'react'

// Functions
import { addStyle, removeStyle } from '../../../functions/textEditorFunctions'

// css
import css from '../css/styleSettings.css'



class LineClampSetting extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  change = (e) => {
    const { _this, styleName } = this.props
    const value = e.target.value

    if (value === '') {
      removeStyle(_this, styleName)
    } else {
      addStyle(_this, {
        style: styleName,
        value
      })
    }
  }

  reset = () => {
    const { _this, styleName } = this.props

    if (styleName) {
      removeStyle(_this, styleName)
    }
  }

  render() {
    const { _this, styleName } = this.props
    const display = _this.state.style[styleName]

    return (
      <div>
        <table>
          <tbody>
            <tr>
              <td className="pd-0 font-0-7">จำนวนบรรทัด (line-clamp)</td>
              <td className="pd-0 font-0-7 text-right">
                <a className={css.btn} onClick={this.reset}>รีเซ็ท</a>
              </td>
            </tr>
          </tbody>
        </table>

        <div>
          <div className={css.boxInput}>
            <table>
              <tbody>
                <tr>
                  <td width="50%" className="pd-0 font-0-8 center">
                    <select
                      className={`browser-default ${css.input} ${css.select}`}
                      onChange={this.change}
                      value={display || '0'}>

                      <option value="">เลือกจำนวนบรรทัด</option>
                      <option value="1">1 บรรทัด</option>
                      <option value="2">2 บรรทัด</option>
                      <option value="3">3 บรรทัด</option>
                      <option value="4">4 บรรทัด</option>
                      <option value="5">5 บรรทัด</option>
                      <option value="6">6 บรรทัด</option>
                      <option value="7">7 บรรทัด</option>
                      <option value="8">8 บรรทัด</option>
                      <option value="9">9 บรรทัด</option>
                      <option value="10">10 บรรทัด</option>
                      <option value="11">11 บรรทัด</option>
                      <option value="12">12 บรรทัด</option>
                      <option value="13">13 บรรทัด</option>
                      <option value="14">14 บรรทัด</option>
                      <option value="15">15 บรรทัด</option>
                    </select>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    )
  }
}

export default LineClampSetting
